import { endLoadingState } from "../basket-v2/basketLoading";

// Show a spinner on form submission
export function setLoading(isLoading) {
  if (isLoading) {
    // Disable the button and show a spinner
    document.querySelector("#submit").setAttribute("disabled", "disabled");
  } else {
    document.querySelector("#submit").removeAttribute("disabled");
    endLoadingState(".basket-overlay");
  }
}
